import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {FileTypes} from '@constants/file-types';

@Component({
    selector: 'scitis-file-download',
    templateUrl: './file-download.component.html',
    styleUrls: ['./file-download.component.scss'],
    standalone: false
})
export class FileDownloadComponent implements OnChanges {

  @Input()
  fileType: FileTypes = FileTypes.TEXT;

  @Input()
  isDisabled: boolean = false;

  @Input()
  fileName: string | undefined;

  @Input()
  title: string = '';

  @Input()
  downloadDetails: string | undefined;

  @Input()
  label: string | undefined;

  @Output()
  prepareDownloadContent: EventEmitter<boolean> = new EventEmitter<boolean>();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.downloadDetails || changes.fileName) {
      this.startDownload();
    }
  }

  private startDownload() {
    if (this.downloadDetails && this.downloadDetails.length > 0 &&
        this.fileName && this.fileName.length > 0) {
      const hiddenElement = document.createElement('a');
      hiddenElement.href = 'data:' + this.fileType.mimeTypesArray[0] + ';charset=utf-8,' + encodeURI(this.downloadDetails);
      hiddenElement.target = '_blank';
      hiddenElement.download = this.fileName;
      hiddenElement.click();
    }
  }

  triggerPrepareDownloadData() {
    this.prepareDownloadContent.emit(true);
  }
}
